import { Component, Inject, OnInit } from '@angular/core';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Trip } from '../../DataStructures/Trip/Trip';

@Component({
  selector: 'app-change-cost',
  templateUrl: './change-cost.component.html',
  styleUrls: ['./change-cost.component.css']
})
export class ChangeCostComponent implements OnInit {

  trip:Trip;
  cost = 0;
  expense = 0;
  driverEarnings = 0;
  constructor(public dialogRef: MatDialogRef<ChangeCostComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private main: MainService) {
      this.trip = data;
      this.cost = this.trip.earnings;
      this.expense = this.trip.expenses;
      this.driverEarnings = this.trip.driverEarnings;
    }

  ngOnInit() {

  }

  isBearer() {
    var payload = this.main.getAdminPayload();
    if (payload.type == 'BEARER') {
      return true;
    }
    return false;
  }

  save(){
    this.trip.earnings = this.cost;
    this.trip.expenses = this.expense;
    this.main.updateTrip(this.trip).then(() =>{
      this.dialogRef.close(true);
    }).catch(e =>{
      this.dialogRef.close(false);
    })
  }

}
